import { render, staticRenderFns } from "./PropertyPanel.vue?vue&type=template&id=47ab714f"
import script from "./PropertyPanel.vue?vue&type=script&lang=js"
export * from "./PropertyPanel.vue?vue&type=script&lang=js"
import style0 from "./PropertyPanel.vue?vue&type=style&index=0&id=47ab714f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports